import './index.scss';
import { withI18n } from 'panda-i18n';
import locale from '@/locales';
import { CnLoading as CnLoadingView } from './loading';
import { hide, show } from './loading-toast';
export var CnLoading = withI18n(CnLoadingView, { locale: locale });
CnLoading.show = show;
CnLoading.hide = hide;
